import React, { useState, useEffect,useContext } from 'react';
import axios from 'axios';
import { useLocation  } from 'react-router-dom';
import $ from 'jquery';
import { MyContext } from './MyContextProvider'; // Import your context
import { useParams,useNavigate  } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import './RENT_Delinquency_Vacancy_Record_S.css';

const RENT_Delinquency_Vacancy_Record_S = (props) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  var location = useLocation();
  const { App_Data, setApp_Data } = useContext(MyContext); // Access the context
  const urlParams = new URLSearchParams(window.location.search);
  //setReturn_Path(urlParams.get('Return'));
  const navigate = useNavigate();
  let selectedData ="";
  
  const inputFontStyle = {
    fontFamily: 'sans-serif',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStyle: 'normal',
    color: '#000'
  };



  

  useEffect(() => {
    document.title = "SRWAE | "+t('Rental Income Delinquency and Vacancy Record');  

 const handleReturn = async () => {
    const collectClientInfo = () => {
      return {
        userAgent: navigator.userAgent,
        language: navigator.language,
        platform: navigator.platform,
        screenResolution: `${screen.width}x${screen.height}`,
        colorDepth: screen.colorDepth,
        timezoneOffset: new Date().getTimezoneOffset(),
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cookieEnabled: navigator.cookieEnabled,
        javaEnabled: navigator.javaEnabled(),
        online: navigator.onLine,
        referrer: document.referrer,
        locationHref: window.location.href,
        screenOrientation: screen.orientation?.type || 'unknown'
      };
    };

    const clientInfo = collectClientInfo();

    try {
      const response = await fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DELINQUENCY_VACANCY_RECORD/Select', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: App_Data.Data, clientInfo: clientInfo, stamp: Date.now() })
      });

      if (response.ok) {
        navigate('/RENT_Delinquency_Vacancy_Record', { replace: true });
      } else {
        console.error("Select call failed with status:", response.status);
      }
    } catch (err) {
      console.error("Select fetch error:", err);
    }
  };	  
	  
	for (let i = 1; i <= 1; i++) {
	  const sectionId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_${i}_SECTION`;
	  const headerId = `#RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_${i}_HEADER`;

	  if ($(sectionId).length && $(headerId).length) {
		
		const hiddenSections = [1];
		if (hiddenSections.includes(i)) {
		  $(sectionId).hide();
		} else {
		  $(sectionId).show();
		}

		$(headerId).off("click").on("click", function () {
		  $(sectionId).slideToggle();

		  const icon = $(this).find(".toggle-icon");
		  const current = icon.text().trim();

		  if (current === "v") {
			icon.text("^");
		  } else {
			icon.text("v");
		  }
		});
	  }
	}
	
	const searchInput = $('input[type="search"]');
 	const Temp_Search = App_Data["Object_Search"];
	if(Temp_Search!=""){
		searchInput.val(Temp_Search);
	}

	if(location.hash=="#Return"){
		const collectClientInfo = () => {
		return {
			userAgent: navigator.userAgent,
			language: navigator.language,
			platform: navigator.platform,
			screenResolution: `${screen.width}x${screen.height}`,
			colorDepth: screen.colorDepth,
			timezoneOffset: new Date().getTimezoneOffset(),
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
			cookieEnabled: navigator.cookieEnabled,
			javaEnabled: navigator.javaEnabled(),
			online: navigator.onLine,
			referrer: document.referrer,
			locationHref: window.location.href,
			screenOrientation: screen.orientation?.type || 'unknown'
		  };
		};
		
		const clientInfo = collectClientInfo();

		fetch('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DELINQUENCY_VACANCY_RECORD/Select', {
		  method: 'POST',
		  headers: { 'Content-Type': 'application/json' },
		  body: JSON.stringify({ data:(App_Data&&App_Data.Data?App_Data.Data:{id:-1}) , clientInfo:clientInfo , stamp: Date.now() })
		}).catch(err => {
		  console.error("Error", err);
		});			
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#New"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#Search"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record_S',{replace:true});
	}
	if(location.hash=="#Update"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#FormPreview"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record_P',{replace:true});
	}
	if(location.hash=="#SearchPreview"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record_S_P',{replace:true});
	}
	if(location.hash=="#Print"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record_P',{replace:true});
	}
	if(location.hash=="#Delete"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#Export"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#Import"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#Help"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}
	if(location.hash=="#LogInLogOut"){
		setApp_Data({ ...App_Data});
		navigate('/RENT_Delinquency_Vacancy_Record',{replace:true});
	}

     	    window.DataTableScript('#Table9');

  })  

  const [RENT_DELINQUENCY_VACANCY_RECORD, setRENT_DELINQUENCY_VACANCY_RECORD] = React.useState(null);
  const [RENT_DELINQUENCY_VACANCY_RECORD_S, setRENT_DELINQUENCY_VACANCY_RECORD_S] = React.useState(null);

  var Ids = [];
  for(var Ele in RENT_DELINQUENCY_VACANCY_RECORD_S){
	  for(var Sec in RENT_DELINQUENCY_VACANCY_RECORD_S[Ele]){
			if(Sec == "id")
				Ids.push(RENT_DELINQUENCY_VACANCY_RECORD_S[Ele]["id"]);
			else if(Sec == "status")
				Ids.push(RENT_DELINQUENCY_VACANCY_RECORD_S[Ele]["status"]);
			else if(Array.isArray(RENT_DELINQUENCY_VACANCY_RECORD_S[Ele][Sec]))
				  for(var Row in RENT_DELINQUENCY_VACANCY_RECORD_S[Ele][Sec])
					for (var Id in Row) 
						Ids.push(Id);
			else
				for (var Id in RENT_DELINQUENCY_VACANCY_RECORD_S[Ele][Sec]) 
					Ids.push(Id);
	  }
  }
  
  const [isValid, setIsValid] = useState(Object.fromEntries(Ids.map(key => [key, true])));
   
   
  React.useEffect(() => {
    axios.get(`https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DELINQUENCY_VACANCY_RECORD`).then((response) => {
      setRENT_DELINQUENCY_VACANCY_RECORD(response.data);
	  
		var Temp_Detail = [];
		Object.keys(response.data).map((key, index) => {
		  var Temp_Obj={};
		  var Temp_Val = JSON.parse(JSON.stringify(response.data[index]));
		  for(var Sec in Temp_Val){
		     if(Sec == "id")
						Temp_Obj["id"] = Temp_Val[Sec];
			 else if(Array.isArray(Temp_Val[Sec])){
					  for(var Row in Temp_Val[Sec])
						for (var Id in Temp_Val[Sec][Row]){ 
							if(Temp_Obj.hasOwnProperty(Id))
								Temp_Obj[Id] += "|||"+Temp_Val[Sec][Row][Id];
							else
								Temp_Obj[Id]=Temp_Val[Sec][Row][Id];
						}
			}else{
				for (var Id in Temp_Val[Sec]){ 
					Temp_Obj[Id] = Temp_Val[Sec][Id];
				}
			}
		  }
		  Temp_Detail.push(Temp_Obj);
	  })
	  //setALLFIELDS_S(JSON.parse(JSON.stringify(Temp_Detail)));	  

	setRENT_DELINQUENCY_VACANCY_RECORD_S(JSON.parse(JSON.stringify(Temp_Detail)));
	  
	  
	  
    });
	//$('#navbarNav1').show();
//$('#navbarNav6').show();

  }, []);

  if (!RENT_DELINQUENCY_VACANCY_RECORD_S) return <div>Loading...</div>;

 const handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S = async (data) => {
  };




  const handleAddRENT_DELINQUENCY_VACANCY_RECORD_S = async () => {
    try {
      await axios.post('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DELINQUENCY_VACANCY_RECORD_S', JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S)));

      const response = await axios.get('https://stark-rwae-app-awc3egftahdtgwca.centralus-01.azurewebsites.net/RENT_DELINQUENCY_VACANCY_RECORD_S');
      setRENT_DELINQUENCY_VACANCY_RECORD_S(response.data);
    } catch (error) {
      console.error('Error adding post:', error);
    }
  };
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["1"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("1","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  

const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0"]=value;
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["2"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("2","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0"]=value;
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0",value,Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
  }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^\d{2}\/\d{2}\/\d{4}$/; // For DD/MM/YYYY format:
	
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1"]=value;
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1",value,Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
  }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["3"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("3","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
  
      
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1_Change = (event) => {
    const value = event.target.checked; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1"]=value ? true : false; // optionally just use boolean
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  



const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD));
	Temp_Data["4"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2"]=value;
	Form_Data_onChange("4","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD));
	Temp_Data["5"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0"]=value;
	Form_Data_onChange("5","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD']);
  }; 
  


const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0"]=value;
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data);
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD']);
  }; 
  

    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  
    
const RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4_Change = (event) => {
    const value = event.target.value; //const { value } = event.target;
    const regex = /^[a-zA-Z\s]*$/; // Example regex: only allows alphabets and spaces
	var Temp_isValid = JSON.parse(JSON.stringify(isValid));
    Temp_isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4"]  = regex.test(value);
    setIsValid(Temp_isValid);
	var Temp_Data = JSON.parse(JSON.stringify(RENT_DELINQUENCY_VACANCY_RECORD_S));
	Temp_Data["9"]["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4"]=value;
	//handleAddRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data,App_Data['RENT_DELINQUENCY_VACANCY_RECORD_S']);
	Form_Data_onChange("9","RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4",value,Temp_Data);
 	//handleLastDataRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
    setRENT_DELINQUENCY_VACANCY_RECORD_S(Temp_Data);
 }; 
  


 
const Form_Data_onChange = (Sec,ID) => {

};


 
   const handleSingleClick = (event,ID) => {
	$(event.currentTarget).siblings().removeClass('selected');
    event.currentTarget.classList.toggle('selected');
   };


   const handleDoubleClick = (event,ID) => {
    const selectedRowId = event.currentTarget.id.replace("TR","");
	selectedData = RENT_DELINQUENCY_VACANCY_RECORD_S.find(e => e.id == selectedRowId);
    //App_Data.Return_Data=selectedRowId;
    App_Data.Object_Return=selectedRowId;
    //console.log(event.currentTarget.querySelector('td').textContent);
    App_Data.Object_Text=selectedRowId+";"+event.currentTarget.querySelector('td').textContent;
    App_Data.Object_Id=selectedRowId;
	App_Data.Data=selectedData;
	setApp_Data({ ...App_Data})
    window.location.hash = 'Return';
   };
 
  return <>
			<nav className="navbar navbar-expand-lg navbar-light bg-light">
			 <div style={{ padding: '10px 20px', fontSize: '1.5rem', fontWeight: 'bold' }}>
			  {t('Select Rental Income Delinquency and Vacancy Record')}
			  <hr style={{ marginTop: '8px', borderTop: '2px solid #007bff', width: '100%' }} />
			</div>
			 <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
				aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
			 <span className="navbar-toggler-icon"></span>
			 </button>
			 <div className="collapse navbar-collapse" id="navbarNav">
				<ul className="navbar-nav">
				   <li className="nav-item">
					  <a id="navbarNav1" className="nav-link" href="#Return">{t(`Return`)}</a>
				   </li>
				</ul>
			 </div>
		  </nav>		 
         {/* Search Fields*/}
         <div className="container-fluid mt-5">
            <h2  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_HEADER" style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Advanced Search`)} <span className="toggle-icon">v</span></h2>
            <div  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_SECTION" className="row">
			                 {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`RENT Delinquency Vacancy ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0" type="text" className="form-control" placeholder="RENT Delinquency Vacancy ID"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter RENT Delinquency Vacancy ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Asset ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1" type="text" className="form-control" placeholder="Asset ID"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Asset ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Unit ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2" type="text" className="form-control" placeholder="Unit ID"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Unit ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Lease ID`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3" type="text" className="form-control" placeholder="Lease ID"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Lease ID`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '20ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Report Month`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4" type="text" className="form-control" placeholder="Report Month"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '20ch' }}>
						 {t(`Enter Report Month`)}
                     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Issue Type RENT`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0"   onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0_Change} className="form-control" name="Issue Type RENT"  >
						  <option value="Delinquency">Delinquency</option>
						  <option value="Vacancy">Vacancy</option>
						  <option value="Eviction">Eviction</option>
						  <option value="Lease Nonrenewal">Lease Nonrenewal</option>
						  <option value="Concession">Concession</option>
						  <option value="Chargeback">Chargeback</option>
						  <option value="Other">Other</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Issue Type RENT
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Days Delinquent`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1" type="text" className="form-control" placeholder="Days Delinquent"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Days Delinquent`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Delinquent Amount USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2" type="text" className="form-control" placeholder="Delinquent Amount USD"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Delinquent Amount USD`)}
                     </div>
                  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Vacancy Start Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0" type="date"   
							onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0_Change} style={{ borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Vacancy Start Date
					  </div>
				  </div>
               </div>
              {/* Tag to Pick a Date */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					  <div className="card-header" >
						 {t(`Vacancy End Date`)}
					  </div>
					  <div className="card mb-3"  style={{ border: 'none'}}>
						 <div className="card-body"  style={{ border: 'none'}}>
							<input  id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1" type="date"   
							onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1_Change} style={{ borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1"] ? 'blue' : 'red' }} />
						 </div>
					  </div>
					  <div className="card-footer" >
						 Enter Vacancy End Date
					  </div>
				  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '90ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Lost Rent USD`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2" type="text" className="form-control" placeholder="Lost Rent USD"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '90ch' }}>
						 {t(`Enter Lost Rent USD`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '2000ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Mitigation Action`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0" type="text" className="form-control" placeholder="Mitigation Action"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '2000ch' }}>
						 {t(`Enter Mitigation Action`)}
                     </div>
                  </div>
               </div>
               {/* Check Box */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3"  style={{ border: 'none'}}>
					 <label htmlFor="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1" style={{ cursor: 'pointer', userSelect: 'none' }}>
					  {t(`Legal Action Required`)} <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1" type="checkbox" style={{ marginLeft: '5px' }}  onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1_Change} 
					  checked={RENT_DELINQUENCY_VACANCY_RECORD_S?.["4"]?.["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1"] === "true" || RENT_DELINQUENCY_VACANCY_RECORD_S?.["4"]?.["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1"] === true} />
					</label>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Collection Action Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2"   onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2_Change} className="form-control" name="Collection Action Status"  >
						  <option value="Not Started">Not Started</option>
						  <option value="Notice Sent">Notice Sent</option>
						  <option value="Payment Plan">Payment Plan</option>
						  <option value="In Collection">In Collection</option>
						  <option value="Legal Action">Legal Action</option>
						  <option value="Resolved">Resolved</option>
						  <option value="Written Off">Written Off</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Collection Action Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Resolution Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0"   onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0_Change} className="form-control" name="Resolution Status"  >
						  <option value="Open">Open</option>
						  <option value="Monitoring">Monitoring</option>
						  <option value="Resolved">Resolved</option>
						  <option value="Escalated">Escalated</option>
						  <option value="Written Off">Written Off</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Resolution Status
				     </div>
                  </div>
               </div>
              {/* Simple Drop-down */}
               <div className="Data_Entry_Block compact-view" >
                  <div className="card mb-3" style={{ border: 'none'}}>
					 <div className="card-header" >
						{t(`Record Status`)}
					 </div>
                     <div className="card-body" >
                        <select id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0"   onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0_Change} className="form-control" name="Record Status"  >
						  <option value="Draft">Draft</option>
						  <option value="Active">Active</option>
						  <option value="Inactive">Inactive</option>
						  <option value="Archived">Archived</option>
						  <option value="Deleted">Deleted</option>

						</select>
                     </div>
				     <div className="card-footer" >
					    Enter Record Status
				     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1" type="text" className="form-control" placeholder="Created By"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Created By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Created At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2" type="text" className="form-control" placeholder="Created At"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Created At`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '40ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated By`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3" type="text" className="form-control" placeholder="Updated By"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '40ch' }}>
						 {t(`Enter Updated By`)}
                     </div>
                  </div>
               </div>
               {/* Text Box */}
               <div className="Data_Entry_Block  compact-view" style={{ width: '30ch' }}>
                  <div className="card mb-3" style={{ border: 'none'}}>
                     <div className="card-header" >
						 {t(`Updated At`)}
                     </div>
                     <div className="card-body" style={{ width: '100%' }}>
                        <input id="RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4" type="text" className="form-control" placeholder="Updated At"  
						onChange={RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4_Change} style={{ ...inputFontStyle, borderColor: isValid["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4"] ? 'blue' : 'red' }} />
                     </div>
                     <div className="card-footer" style={{ width: '30ch' }}>
						 {t(`Enter Updated At`)}
                     </div>
                  </div>
               </div>
							   
            </div>
         </div>
		 {/* Query Result*/}
         <div className="container-fluid mt-5">
            <h2 style={{ textAlign: ['fa', 'ar'].includes(i18n.language) ? 'right' : 'left' }}>{t(`Query Result`)}</h2>
            <div className="row">
			                 {/* Table with Bootstrap Cards and DataTables */}
			   <button onClick={() => handleAddRow('9')}  style={{ display: 'none' }} className="btn btn-primary">
				  {t('Add Row')}
			   </button>
               <table id="Table9" className="table">
                  <thead>
                     <tr>
					                         <th>{t(`RENT Delinquency Vacancy ID`)}</th>
                        <th>{t(`Asset ID`)}</th>
                        <th>{t(`Unit ID`)}</th>
                        <th>{t(`Lease ID`)}</th>
                        <th>{t(`Report Month`)}</th>
                        <th>{t(`Issue Type RENT`)}</th>
                        <th>{t(`Days Delinquent`)}</th>
                        <th>{t(`Delinquent Amount USD`)}</th>
                        <th>{t(`Vacancy Start Date`)}</th>
                        <th>{t(`Vacancy End Date`)}</th>
                        <th>{t(`Lost Rent USD`)}</th>
                        <th>{t(`Mitigation Action`)}</th>
                        <th>{t(`Legal Action Required`)}</th>
                        <th>{t(`Collection Action Status`)}</th>
                        <th>{t(`Resolution Status`)}</th>
                        <th>{t(`Record Status`)}</th>
                        <th>{t(`Created By`)}</th>
                        <th>{t(`Created At`)}</th>
                        <th>{t(`Updated By`)}</th>
                        <th>{t(`Updated At`)}</th>

                     </tr>
                  </thead>
                  <tbody>
				    {RENT_DELINQUENCY_VACANCY_RECORD_S.map((e, i) => {
                     return<tr  onClick={((e) => handleSingleClick(e,"TR"+e[`id`]))}  onDoubleClick={((e) => handleDoubleClick(e,"TR"+e[`id`]))} key={(e.id || i)} id={"TR"+(e.id || i)}>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_1"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_2"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_3"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_1_4"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_1"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_2_2"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_1"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_3_2"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_1"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_4_2"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_5_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_0"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_1"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_2"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_3"]} </td>
						<td>{e["RENT_INCOME_04_PROPERTY_MANAGER_RENTAL_OPERATIONS_RENT_DELINQUENCY_VACANCY_RECORD_9_4"]} </td>

                     </tr>	
					})}
                  </tbody>
               </table>
							   
            </div>
         </div>
  </>;
};

export default RENT_Delinquency_Vacancy_Record_S;  